import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const Row = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 16px;
`;

const Badge = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px;
  border: 1px solid #e7e7e7;
  border-radius: 12px;
`;

const Rating = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
`;

export default function BadgeRow({
  leftBadgeTitle,
  leftBadgeText,
  rating,
  reviewsCount,
}) {
  return (
    <Row>
      <Badge>
        <div style={{ fontWeight: 700 }}>{leftBadgeTitle}</div>
        <div style={{ color: "#717171" }}>{leftBadgeText}</div>
      </Badge>

      {(rating || reviewsCount) && (
        <Rating>
          <span>★ {rating || "4.8"}</span>
          {reviewsCount ? (
            <span style={{ color: "#717171" }}>{reviewsCount} reviews</span>
          ) : null}
        </Rating>
      )}
    </Row>
  );
}

BadgeRow.propTypes = {
  leftBadgeTitle: PropTypes.string.isRequired,
  leftBadgeText: PropTypes.string.isRequired,
  rating: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  reviewsCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
